module.exports = __webpack_public_path__ + "media/images/patent/y_4-47f537d4f2636a8b9539094c1daf3918.jpg";